import {
  getGoodPick, listDataGoodPick, deleteGoodPick, batchCreateGoodPick, updateGoodPick, updateSummary
} from '@/zsm-api-new/goodPick.js'
const state = {

}

const mutations = {

}

const actions = {
  // 更新专集概要信息
  updateSummary({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateSummary(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改单独信息
  updateGoodPick({ commit }, frontId) {
    return new Promise((resolve, reject) => {
      updateGoodPick(frontId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取单独的商品集
  getGoodPick({ commit }, data) {
    return new Promise((resolve, reject) => {
      getGoodPick(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取列表
  listDataGoodPick({ commit }, data) {
    return new Promise((resolve, reject) => {
      listDataGoodPick(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 删除内容
  deleteGoodPick({ commit }, data) {
    return new Promise((resolve, reject) => {
      deleteGoodPick(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 添加商品集
  batchCreateGoodPick({ commit }, data) {
    return new Promise((resolve, reject) => {
      batchCreateGoodPick(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
